/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Fix_OpenInputs */

const en_fix_open = /** @type {(inputs: Fix_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fix ${i?.name}`)
};

const de_fix_open = /** @type {(inputs: Fix_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} korrigieren`)
};

/**
* | output |
* | --- |
* | "Fix {name}" |
*
* @param {Fix_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_open = /** @type {((inputs: Fix_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_open(inputs)
	return en_fix_open(inputs)
});